import React, { createContext, useEffect, useContext, useReducer } from "react";
import { getLocalStorage, setLocalStorage } from "utils/localStorage";

const UserContext = createContext();

const initialState = {
  authToken: getLocalStorage("authToken", ""),
  role: "",
  username: "",
};

function userReducer(state, action) {
  switch (action.type) {
    case "login": {
      return {
        ...state,
        authToken: action.payload.authToken,
        role: action.payload.role,
        username: action.payload.username,
      };
    }
    case "setToken": {
      return { ...state, authToken: action.payload };
    }
    case "logout": {
      return { authToken: "", role: "", username: "" };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  const [state, dispatch] = useReducer(userReducer, initialState);
  const value = { state, dispatch };

  useEffect(() => {
    setLocalStorage("authToken", state.authToken);
  }, [state.authToken]);
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

function useUserContext() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useCount must be used within a CountProvider");
  }
  return context;
}

export { UserProvider, useUserContext };
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                 
                 
                 
                                            
                             
                             
                                                                          
                                          
                                                        
                                          
                                                                 
                                                 
                                                     
                                                                         
                                                 
                                                                         
                                                 
                                                                       
                                                                                                                                                                      
                                                                                                                                                                                                                                                                                                                                                                                                                                                 
                                             
                                             
                                                                                                                                                                                    